import { render } from "./UploadIcon16.vue.js?vue&type=template&id=22dd6bba!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./UploadIcon16.vue?vue&type=template&id=22dd6bba"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__